import PURPLE_ARROW_1 from './purple-arrow-1.svg'
import PURPLE_ARROW_2 from './purple-arrow-2.svg'
import PURPLE_ARROW_3 from './purple-arrow-3.svg'
import { TipPosition } from 'components/OnboardingBotPreview'

export const STEP_TYPES = Object.freeze({
  PRODUCT_NAME: {
    arrowSrc: PURPLE_ARROW_1,
    key: "product name",
    tipText: "We’ll use that name in this question!",
    title: "What’s the name of your product?",
    previewTextDefault: "(product or company)",
    placeholderDefault: "Product or company name"
  },
  VALUE_PROP: {
    arrowSrc: PURPLE_ARROW_2,
    key: "value prop",
    tipText: "Your value prop will go here, too 😉",
    title: "What’s your value prop?",
    previewTextDefault: "achieve your goals",
    placeholderDefault: `Value prop, i.e. "achieve your goals"`
  },
  INDUSTRY: {
    arrowSrc: PURPLE_ARROW_3,
    key: "industry",
    tipPosition: TipPosition.RESPONSE,
    tipText: "And your industry will go in this button",
    title: "What’s your industry?",
    previewTextDefault: "chat platforms",
    placeholderDefault: `Industry, i.e. "chat platforms"`
  }
})


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookDemoRequestStep/constants.js